import { render } from "./ShoppingCategoryList.vue?vue&type=template&id=637d24b7&scoped=true&ts=true"
import script from "./ShoppingCategoryList.vue?vue&type=script&lang=ts"
export * from "./ShoppingCategoryList.vue?vue&type=script&lang=ts"

import "./ShoppingCategoryList.vue?vue&type=style&index=0&id=637d24b7&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637d24b7"]])

export default __exports__